import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Company } from 'src/app/models/company.model';
import { Role } from 'src/app/models/role.model';
import { User } from 'src/app/models/user.model';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { RoleService } from 'src/app/services/role/role.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-profile-loader',
  templateUrl: './profile-loader.component.html',
  styleUrls: ['./profile-loader.component.scss'],
})
export class ProfileLoaderComponent {
  userDetails: User = new User();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private companyService: CompanysService,
    private roleService: RoleService,
    private toastr: ToastrService
  ) {}
  companies: Company[] = [];
  roles: Role[] = [];
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
 accessAllRole: boolean=false;
 companyAccess:boolean=false;
 accessUpdate:boolean=false;
 accessCancel:boolean=false;
 FnameAccess:boolean=false;
 LnameAccess:boolean=false;
 EmailAccess:boolean=false;
 userNameAccess:boolean=false;
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User' || loggedInuserRole.role =='Internal User' || loggedInuserRole.role=='Regional User')
      {
        this.accessAllRole = true;
        this.companyAccess = true;
        this.accessUpdate = true;
        this.accessCancel = true;
        // this.FnameAccess = true;
        // this.LnameAccess = true;
        // this.EmailAccess=true;
        // this.userNameAccess=true;
      }
      


    this.roleService.getAllRoleType().subscribe({
      next: (role) => {
        this.roles = role;
        console.log(role);
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.route.paramMap.subscribe({
      next: (params) => {
        const UserId = params.get('id');

        if (UserId) {
          this.userService.getUser(UserId).subscribe({
            next: (response) => {
              this.userDetails = response;
            },
          });
        }
      },
    });

    this.companyService.getAllCompanys().subscribe({
      next: (companies) => {
        this.companies = companies;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

  reloader() {
    window.location.reload();
  }

  UpdateUser() {
    const matchingRole = this.roles.find(
      (role) => role.Id === this.userDetails.RoleId
    );
    if (matchingRole) {
      this.userDetails.RoleName = matchingRole.Name;
    }
    this.userDetails.Type = '1';
    if (this.userDetails.PhoneNumber == null) {
      this.userDetails.PhoneNumber = '123456789';
    }
    this.userDetails.Password = '';
    this.userService
      .updateUser(this.userDetails.UserId, this.userDetails)
      .subscribe({
        next: (response) => {
          this.toastr.success('Profile Updated Successfully.', 'Information');
          this.router.navigate(['/user']);
        },
      });
  }

  // deleteUser(UserId: string) {
  //   this.userService.deleteUser(UserId).subscribe({
  //     next: (response) => {
  //       this.toastr.error('User Deleted Successfully.', 'Information');
  //       this.router.navigate(['/user']);
  //     },
  //   });
  // }
}
